/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React, { FC, useState } from 'react'
import classNames from 'classnames'
import { CenterPopup, Toast } from 'antd-mobile'
import { isUserLogin, userLogin, gotoPage, sniff } from '@/util'

import { LaunchApp, Loading } from '@/components'
import Api from '@/api'

// 样式
import style from './CouponAction.module.scss'
import { CenterPopupProps } from 'antd-mobile/es/components/center-popup'


type Mode = 'orange'

type Style = {
  // 领取按钮包裹层的额外样式
  btnStyle?: React.CSSProperties,
}

type CouponActionProps = {
  couponId: number // 优惠券id
  mode?: Mode
  // 领取按钮包裹层的额外class
  btnExtraClass?: string
  // 已领取按钮包裹层的额外class
  gettedBtnClass: string,
  // 按钮文字
  btnText?: string
  // 领取优惠券后按钮文字
  gettedBtnText?: string
  // 唤起地址
  openUrl: string
  // 是否已经领取
  isReceive: number // 1 已领取， 0 未领取
  // 弹窗属性
  modalProps: CenterPopupProps
  // 组件使用对象
  comUser: string
  // app内对应的跳转页面
  appPath: string
  // 是否活动领券(根据接口传参activity_coupon_id/coupon_id，后端区分活动领券/商家发券)
  isActive: boolean
  // 是否展示loading动画
  showLoading: boolean,
} & Style


const CouponAction: FC<CouponActionProps> = (props) => {
  const { couponId: coupon_id, openUrl, btnStyle, btnText = '立即领取', gettedBtnText = '去APP内使用', gettedBtnClass, btnExtraClass, children, mode = 'orange', isReceive = 0, modalProps, comUser = 'showCoupon', appPath = '', isActive = false, showLoading = true } = props
  const [modalVisible, setModalVisible] = useState(false)
  const [couponStatus, setCouponStatus] = useState(-1)

  interface Handler {
    [key: string]: { appReceive: boolean, received: Function, apiCode0: Function, apiCode10008E: Function },
  }
  const HANDLERS: Handler = {
    showCoupon: {
      appReceive: false, // 是否开启站内领取
      received: (): void => { // 已领取状态处理
        setModalVisible(true)
      },
      apiCode0: (): void => { // 领取接口状态码0处理
        setModalVisible(true)
      },
      apiCode10008E: (receiveData: { data: {message: string} ,error: { message: string } }): void => { // 领取接口状态码10008处理
        if (modalProps?.closeOnMaskClick) {
          setCouponStatus(1) // 改变领取状态
          Toast.show({
            content: receiveData.error?.message || receiveData.data?.message,
            duration: 2000,
          })
        } else {
          setModalVisible(true)
        }
      },
    },
    receiveCoupon: {
      appReceive: true,
      received: (): void => {
        gotoPage(appPath)
      },
      apiCode0: (): void => {
        Toast.show({
          icon: 'success',
          content: '领取成功',
          duration: 1000,
        })
      },
      apiCode10008E: (): void => {
        return
      },
    },
    receiveCoupon1: {
      appReceive: true,
      received: (): void => {
        return
      },
      apiCode0: (): void => {
        Toast.show({
          icon: 'success',
          content: '领取成功',
          duration: 1000,
        })
      },
      apiCode10008E: (): void => {
        return
      },
    },
  }

  let _comUser = comUser
  const handlerKeys = Object.keys(HANDLERS) || []
  if (handlerKeys.indexOf(comUser) === -1) {
    _comUser = handlerKeys[0]
  }
  const myHandler = HANDLERS[_comUser] || {}

  const actionCoupon = async () => {
    // 未登录则跳转登录页
    if (!isUserLogin()) {
      userLogin()
      return
    }
    // 已领取则直接返回
    if (couponStatus === 0 || couponStatus === 1) {
      setCouponStatus(1) // 改变领取状态
      myHandler.received()
      return
    }
    try {
      const payLoad = isActive ? { activity_coupon_id: coupon_id } : { coupon_id }
      const receiveData: any = await Api.post('/coupon/receive', payLoad, {
        structured: false,
      })
      if (receiveData?.data?.code == 0) {
        myHandler.apiCode0()
        setCouponStatus(0) // 改变领取状态
      } else if (receiveData?.error?.code == 10008) { // 已经领取
        myHandler.apiCode10008E()
      } else {
        Toast.show({
          content: receiveData.error?.message || receiveData.data?.message,
          duration: 2000,
        })
      }
    } catch (error) {
      console.log(error)
    }
  }

  // 站内/站外领券操作
  const actionCoupon_ = () => {
    if (!(sniff.isUboxApp && myHandler.appReceive)) return
    actionCoupon()
  }

  const actionBtn = () => {
    // btn类名
    const btnClass = classNames(style.btn,
      btnExtraClass,
      `${style[mode]}`)
    const isGetted = isReceive === 1 || couponStatus !== -1
    const LaunchAppLaunchErrorProps = (
      isReceive === 0 ? {
        launchError: () => {
          actionCoupon()
        },
      } : null
    )
    return <div className={btnClass}
        onClick={(): void => {
        if (!sniff.isUboxApp && showLoading) {
          Loading.show({
            duration: 1700,
          })
        }
      }}
        style={btnStyle}>
      {
        children ? <>{children}</> : <>
          {/* 弹窗可关闭时，已经领取优惠券则将按钮变为唤起按钮 */}
          {
            isGetted ?
              <LaunchApp
                  className={gettedBtnClass}
                  fixed={false}
                  onClick={(): void => { myHandler.received() }}
                  openUrl={openUrl}
              >
                {gettedBtnText}
              </LaunchApp>
              :
              <LaunchApp
                  fixed={false}
                  onClick={actionCoupon_}
                  {
                ...LaunchAppLaunchErrorProps
                }
                  openUrl={openUrl}
              >
                {
                  couponStatus === -1 ?
                    btnText :
                    gettedBtnText
                }
              </LaunchApp>
          }
        </>
      }
    </div>
  }

  const successModal = () => {
    // icon类名
    const iconClass = classNames(style.iconSuccess,
      `${style[mode]}`)
    // 按钮类名
    const btnClass = classNames(style.modalBtn,
      `${style[mode]}`)
    // 弹窗容器类名
    const wrapClass = classNames(style.wrap,
      `${style[mode]}`)

    return <CenterPopup
        bodyClassName={
          wrapClass
        }
        getContainer={document.body}
        visible={modalVisible}
        {...modalProps}
    >
      <div className={style.title}>
        <p className={iconClass}></p>
        <p className={style.text}>
          {couponStatus === 0 ? '领取成功' : '你已经领取'}
        </p>
      </div>
      <div className={style.tips}>
        <p>已发放至 【个人中心】 -【我的优惠券】</p>
      </div>
      <LaunchApp extraClass={btnClass}
          fixed={false}
          openUrl={openUrl}
      >
        去APP内使用
      </LaunchApp>
    </CenterPopup>
  }

  return <div>
    {actionBtn()}
    {successModal()}
  </div>
}

export default CouponAction